import Router from 'js-dom-router';
import 'vidstack/player';
import 'vidstack/player/layouts';
import 'vidstack/player/ui';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { CustomEase } from 'gsap/CustomEase';

import { lenis } from './common';
import { gsapCounter } from './lib/gsapEffects/gsapCounter';
import { initLandingPage } from './pages/landing';
import { initTopbar } from './components/topBar';
import { initFooterMap } from './components/footerMap';
import { initSelect, initSelects } from './components/select';
import { initTelInputs } from './components/telInput';
import { initCookiePopup } from './components/cookiePopup';
import { initForms } from './components/forms';
import { initHorizontalAccordions } from './components/horizontalAccordion';
import { initExpertsPage } from './pages/experts';
import { initNewsPage } from './pages/news';
import { initInterfaceStates } from './lib/interfaceStates';
import { initTreatmentPage } from './pages/treatment';
import { initWherePage } from './pages/where';
import { initVideoBlocks } from './components/videoBlock';
import { initTechnologyPage } from './pages/technology';
import { initVideoPlayers } from './components/videoPlayer';
import { initCatalogPage } from './pages/catalog';
import { initWowPage } from './pages/wow';
import { initAllWpContent } from './components/wpContent';
import { initAllLangSelects } from './components/langSelect';

// Global js
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(CustomEase);
gsap.registerEffect(gsapCounter());

// Synchronize Lenis scrolling with GSAP's ScrollTrigger plugin
lenis.on('scroll', ScrollTrigger.update);

// Add Lenis's requestAnimationFrame (raf) method to GSAP's ticker
// This ensures Lenis's smooth scroll animation updates on each GSAP tick
gsap.ticker.add((time) => {
  lenis.raf(time * 1000); // Convert time from seconds to milliseconds
});

// Disable lag smoothing in GSAP to prevent any delay in scroll animations
gsap.ticker.lagSmoothing(0);

initInterfaceStates();
initTopbar();
initFooterMap();
initSelects();
initTelInputs();
initCookiePopup();
initForms();
initHorizontalAccordions();
initVideoBlocks();
initVideoPlayers();
initAllWpContent();
initAllLangSelects();

// Per page type js
new Router(document.body)
  .on('page--is-landing', initLandingPage)
  .on('page--is-treatment', initTreatmentPage)
  .on('page--is-experts', initExpertsPage)
  .on('page--is-tech', initTechnologyPage)
  .on('page--is-wow', initWowPage)
  .on('page--is-news', initNewsPage)
  .on('page--is-where', initWherePage)
  .on('page--is-catalog', initCatalogPage)
  .ready();

console.log('🪐 Global JS initialized.');
